export default __webpack_public_path__ + "static/media/tewodros.9e69de61.jpg";